module.exports = __webpack_public_path__ + "static/img/page_09.230a13aa.png";